import { Instagram, Tiktok, Youtube, Linkedin, Pinterest, Headphones } from 'react-bootstrap-icons'

export const PROVIDER_ICONS = {
  instagram: Instagram,
  tiktok: Tiktok,
  youtube: Youtube,
  linkedin: Linkedin,
  pinterest: Pinterest,
  podcast: Headphones,
}

export const PROVIDER_COLORS = {
  instagram: 'text-pink-500',
  tiktok: 'text-black dark:text-white',
  youtube: 'text-red-600',
  linkedin: 'text-rb-linkedin',
  pinterest: 'text-red-700',
  podcast: 'text-purple-600',
}

const ACTION_TYPE_LABELS = {
  instagram_reel: 'Reel',
  instagram_story: 'Story',
  instagram_post: 'Post',
  instagram_carousel_post: 'Carousel',
  tiktok_video: 'Video',
  youtube_video: 'Video',
  youtube_short: 'Short',
  linkedin_post: 'Post',
  linkedin_video: 'Video',
  linkedin_newsletter: 'Newsletter',
  pinterest_pin: 'Pin',
  podcast_episode: 'Episode',
  other_item: 'Other',
}

export function actionTypeLabel(actionType) {
  return ACTION_TYPE_LABELS[actionType] || actionType
}

// What kind of asset a given action_type actually expects, so the upload
// section's own heading never contradicts itself (e.g. asking for "video"
// then only accepting image formats below it, or vice versa). Story is
// treated as video since the checklist library's own copy for it
// ("Video is created in portrait format") assumes video.
const ACTION_TYPE_MEDIA_KIND = {
  instagram_reel: 'video',
  instagram_story: 'video',
  instagram_post: 'image',
  instagram_carousel_post: 'image',
  tiktok_video: 'video',
  youtube_video: 'video',
  youtube_short: 'video',
  linkedin_post: 'image',
  linkedin_video: 'video',
  pinterest_pin: 'image',
  podcast_episode: 'audio',
}

const VERTICAL_ACTION_TYPES = new Set(['instagram_reel', 'instagram_story', 'tiktok_video', 'youtube_short'])

// Keep this in sync with DraftUploader#extension_allowlist
// (app/uploaders/draft_uploader.rb) - images (incl. HEIC), video, audio, and
// common document formats, accepted regardless of the action's own expected
// kind. A Post slot can still take a supporting PDF/doc; the label above is
// a hint about what's primarily expected, not a hard restriction.
const SUPPORTED_UPLOAD_EXTENSIONS = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/heic': ['.heic'],
  'video/mp4': ['.mp4'],
  'video/quicktime': ['.mov'],
  'audio/mpeg': ['.mp3'],
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'text/plain': ['.txt'],
}
// Rendered as individual chips (see FileDropzone.jsx) rather than one long
// comma-separated sentence - a plain string reads fine at 4-5 formats, but
// wraps into a ragged, hard-to-scan block at this list's actual length.
const SUPPORTED_UPLOAD_FORMATS = ['JPG', 'JPEG', 'PNG', 'HEIC', 'MP4', 'MOV', 'MP3', 'PDF', 'DOC', 'DOCX', 'TXT']

// Heading + dropzone copy for the Upload section - action_type-aware so an
// Instagram Post correctly says "Upload image" rather than a one-size-fits-
// all "Upload video" regardless of what's actually expected.
export function uploadCopy(actionType) {
  const kind = ACTION_TYPE_MEDIA_KIND[actionType] || 'file'
  const label = { video: 'Upload video', image: 'Upload image', audio: 'Upload audio', file: 'Upload file' }[kind]
  const formatNote = VERTICAL_ACTION_TYPES.has(actionType) ? '(vertical format)' : null

  return {
    label,
    formatNote,
    acceptedFileTypes: SUPPORTED_UPLOAD_EXTENSIONS,
    hintText: SUPPORTED_UPLOAD_FORMATS,
  }
}
